import { useMemo } from 'react'
import { MarketingCampaignType } from 'api/Trading-Accounts/Types/MarketingCampaignType'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'

import { CampaignResultsProvider } from './providers/CampaignResultsProvider'
import { MarginBonusResultsProvider } from './providers/MarginBonusResultsProvider'
import { MarketingCampaignResultsProvider } from './providers/MarketingCampaignResultsProvider'

export const useCampaignResultsProvider = (
  campaignTypeId: number,
  campaignId: string
): CampaignResultsProvider => {
  const api = useApiClient(TradingAccountsApiClient)

  return useMemo(() => {
    if (campaignTypeId === MarketingCampaignType.MarginBonus) {
      return new MarginBonusResultsProvider(api, campaignId)
    }
    return new MarketingCampaignResultsProvider(api, campaignId, campaignTypeId)
  }, [api, campaignId, campaignTypeId])
}
